import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getMemberInsightProducers } from 'src/app/home/adapters'
import { memberInsightsKeys } from 'src/app/home/queries/member-insights-keys'

const ONE_HOUR_MS = 60 * 60 * 1000

export interface IUseMemberInsightProducersQueryParams {
  enabled: boolean
}

export const useMemberInsightProducersQuery = (
  params: IUseMemberInsightProducersQueryParams,
): UseQueryResult<string[], Error> => {
  return useQuery({
    queryKey: memberInsightsKeys.producers(),
    meta: { silent: true },
    staleTime: ONE_HOUR_MS,
    queryFn: async (): Promise<string[]> => {
      const response = await getMemberInsightProducers()
      return response.producers
    },
    enabled: params.enabled,
  })
}
